<template>
    <a-form ref='form' :model='search' :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
      <a-form-item label="二维码号" name='code_sn'>
        <a-input style="width: 270px" v-model:value="search.code_sn" placeholder="请输入关键词进行搜索" />
      </a-form-item>
      <a-form-item label="二维码类型" name='code_type'>
        <a-select v-model:value="search.code_type" :style="{width:'140px'}" placeholder="全部">
          <a-select-option value="">全部</a-select-option>
          <a-select-option :value="1">大标</a-select-option>
          <a-select-option :value="2">中标</a-select-option>
          <a-select-option :value="3">小标</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="扫码录入时间" name='time'>
        <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD ' format='YYYY-MM-DD' @change="changTime" />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" htmlType='submit'>搜索</a-button>
      </a-form-item>
    </a-form>
    <p class="p-t-20">退货商品总数：{{orderData.code_num}}</p>
    <a-table class='m-t-20' :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='list'>
      <template #title_num>
        退货数量
        <a-tooltip placement='right'>
          <template #title>包装的最小单位数量</template>
          <InfoCircleOutlined />
        </a-tooltip>
      </template>
      <template v-slot:code_sn="{ record }">
        <a href="javascript:;" v-has:antiAuditQuery='()=>{$router.push("/antiFleeingGoods/marketAudit/tracking?code="+record.code_sn)}'>{{record.code_sn}}{{record.virtual_sn!=0?'(垛标退货)':''}}</a>
      </template>
    </a-table>
    <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper
      :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange"
      @showSizeChange="pageSizeChange" />
</template>
<script>
  import { InfoCircleOutlined } from "@ant-design/icons-vue";
  import { reactive, ref, toRefs, onMounted, inject } from "vue";
  import { iscode } from "@/utils/app";
  import { message } from "ant-design-vue";
  import { getRefundOrderMore,getRefundOrderCode } from "@/api/antiFleeing";
  const defSearch = {
    page: 1,
    limit: 10,
    code_sn: "",
    code_type: "",
    start_time: "",
    end_time: ""
  };
  export default {
    components: {InfoCircleOutlined},
    props:{id:String},
    setup(props) {
      const search = ref({ ...defSearch });
      const state = reactive({
        orderData:{},
        time: [],
        listLoading:false,
        list:[],
        total:0,
        columns: [
          {
            title: "二维码号",
            dataIndex: "code_sn",
            key: "code_sn",
                    slots: { customRender: "code_sn" },
          },
          {
            title: "二维码类型",
            dataIndex: "code_type_text",
            key: "code_type_text",
          },
          {
            title: "商品名称",
            dataIndex: "product_name",
            key: "product_name"
          },
          {
            title: "商品规格",
            dataIndex: "product_sku_name",
            key: "product_sku_name",
            customRender:({record})=>{
              return (record.product_sku_name&&record.product_sku_name!='0') ? record.product_sku_name:'单规格'
            } 
          },
          {
            dataIndex: "code_num",
            key: "code_num",
            slots: { title: 'title_num' }
          },
          {
            title: "扫码时间",
            dataIndex: "create_time",
            key: "create_time",
          }
        ]
      });
      const $route = inject("$route");
      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData();
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData();
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData();
      };
      const changTime = (e) => {
        search.value.start_time = e[0];
        search.value.end_time = e[1];
      };
      //获取详情
      const getMore = async () => {
        const hide = message.loading("正在加载中...", 0);
        let res = await getRefundOrderMore(props.id ).then((res) => res.data).catch(error => error);
        if (iscode(res)) {
          state.orderData = res.data;
        } else {
          message.error(res.msg);
        }
        setTimeout(hide);
      };
      //获取二维码明细
      const initData = async () => {
        state.listLoading = true
        let res = await getRefundOrderCode({...search.value,id:props.id}).then((res) => res.data).catch(error => error);
        if (iscode(res)) {
          state.list = res.data;
          state.total = res.meta.total
        } else {
          message.error(res.msg);
        }
        state.listLoading = false
      };
      onMounted(() => {
        if($route.query.type == 'channel'){
          state.columns.splice(3,0,{
            title: "退货人名称",
            dataIndex: "from",
            key: "from",
          })
        }
        getMore();
        initData();
      });
      return {
        ...toRefs(state),
        changTime,
        search,
        pageSearchChange,
        pageCurrentChange,
        pageSizeChange,
      };
    },
  };
</script>